// extracted by mini-css-extract-plugin
export var revs = "style-module--revs--6d959";
export var swiperBtnNext = "style-module--swiper-btn-next--bdda0";
export var swiperBtnPrev = "style-module--swiper-btn-prev--517ac";
export var swiperButtons = "style-module--swiper-buttons--a6c76";